module.exports = __webpack_public_path__ + "img/slider_20.db70a1fa.jpg";